export const BOUNDED_FIELDS_TO_DISABLE = [
  'videoQuestions',
  'inhouseQuestion',
  'knockoutQuestions',
  'businessQuestions',
  'orderOfQuestionsModules'
];
